import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePortalAuth } from '../../context/PortalAuthContext';

function CustomerForgotPassword() {
  const { forgotPassword } = usePortalAuth();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await forgotPassword(email);

    if (result.success) {
      setSuccess(true);
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  if (success) {
    return (
      <div className="portal-auth-page">
        <div className="portal-auth-container">
          <div className="portal-auth-header">
            <h1>Check Your Email</h1>
            <p>If an account exists for {email}, we've sent a password reset link.</p>
          </div>
          <Link to="/portal/login" className="portal-btn-primary" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
            Return to Login
          </Link>
        </div>
        <style>{portalStyles}</style>
      </div>
    );
  }

  return (
    <div className="portal-auth-page">
      <div className="portal-auth-container">
        <div className="portal-auth-header">
          <h1>Reset Password</h1>
          <p>Enter your email to receive a reset link</p>
        </div>

        {error && (
          <div className="portal-message error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="portal-auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              placeholder="your@email.com"
            />
          </div>

          <button type="submit" className="portal-btn-primary" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="portal-auth-links">
          <Link to="/portal/login">Back to Login</Link>
        </div>
      </div>
      <style>{portalStyles}</style>
    </div>
  );
}

const portalStyles = `
  .portal-auth-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
    padding: 20px;
  }
  .portal-auth-container {
    background: white;
    border-radius: 16px;
    padding: 40px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  }
  .portal-auth-header {
    text-align: center;
    margin-bottom: 32px;
  }
  .portal-auth-header h1 {
    font-size: 1.75rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 8px 0;
  }
  .portal-auth-header p {
    color: #64748b;
    margin: 0;
    font-size: 0.95rem;
  }
  .portal-message.error {
    background: #fef2f2;
    color: #dc2626;
    border: 1px solid #fecaca;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 24px;
    font-size: 0.9rem;
  }
  .portal-auth-form .form-group {
    margin-bottom: 20px;
  }
  .portal-auth-form label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 6px;
  }
  .portal-auth-form input {
    width: 100%;
    padding: 12px 14px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 1rem;
    box-sizing: border-box;
  }
  .portal-auth-form input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  }
  .portal-btn-primary {
    width: 100%;
    padding: 14px 20px;
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
  }
  .portal-btn-primary:hover:not(:disabled) {
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  }
  .portal-btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  .portal-auth-links {
    text-align: center;
    margin-top: 24px;
  }
  .portal-auth-links a {
    color: #3b82f6;
    text-decoration: none;
    font-size: 0.9rem;
  }
  .portal-auth-links a:hover {
    text-decoration: underline;
  }
`;

export default CustomerForgotPassword;
